import { Helmet } from 'react-helmet-async';
import { Flex, useMultiStyleConfig } from '@chakra-ui/react';

import { AuthenticatedPageWrapperProps } from './types';

function AuthenticatedPageWrapper({
  children,
  title,
  hasBanner = false,
}: AuthenticatedPageWrapperProps) {
  const styles = useMultiStyleConfig('AuthenticatedPageWrapper', { hasBanner });

  return (
    <>
      <Helmet>
        <title>{title} | Aslan</title>
      </Helmet>
      <Flex sx={{ ...styles.container }}>{children}</Flex>
    </>
  );
}

export default AuthenticatedPageWrapper;
